/* eslint-disable no-console */

import {register} from 'register-service-worker'
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {isPlatform} from "@ionic/vue";
import {purgeLegacyWebCaches} from "@/services/legacyCacheCleanup";


if (process.env.VUE_APP_WEB_BUILD === 'yes') {
    purgeLegacyWebCaches().catch((error) => {
        console.warn('Legacy cache cleanup failed', error)
    })
} else if (process.env.VUE_APP_ENV === 'production'
    && !isPlatform('capacitor')
    && process.env.VUE_APP_WEB_BUILD !== 'yes') {

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      Observable.emit(ObservableEvent.PWAUpdateAvailable)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
